// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2qpoR","overflowing":"ReadFullNote_overflowing__vObfe"};